export var ConnectedDisconnected;
(function (ConnectedDisconnected) {
  ConnectedDisconnected["CONNECTED"] = "Connected";
  ConnectedDisconnected["DISCONNECTED"] = "Disconnected";
})(ConnectedDisconnected || (ConnectedDisconnected = {}));